import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const APP_NAME = "[RAMS-TRAMS MRTJ]";

// Route -> human-friendly page title
const ROUTE_TITLES = {
  "/": "Overview",
  "/reliability": "Reliability",
  "/availability": "Availability",
  "/maintainability": "Maintainability",
  "/safety": "Safety",
  "/pareto": "Pareto Analysis",
  "/trend": "Trend Analysis",
  "/failure": "Failure Analysis",
  "/subsystem": "Subsystem Analysis",
  "/rollingstock": "Rollingstock Failure",
  "/events": "Event Explorer",
  "/reports": "Reports",
  "/spm": "SPM / OTP",
  "/power/tss": "Power Consumption – TSS",
  "/power/rss": "Power Consumption – RSS",
  "/settings": "Settings",
  "/login": "Login",
  "/kiosk": "Kiosk Display",
};

/**
 * Keeps the browser tab title in sync with the current route.
 * Format: "<Page> · [RAMS-TRAMS MRTJ]" (falls back to just the app name).
 */
export default function TitleManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    const page = ROUTE_TITLES[pathname];
    document.title = page ? `${page} · ${APP_NAME}` : APP_NAME;
  }, [pathname]);

  return null;
}
